export default __webpack_public_path__ + "static/media/modal.3f793977.less";